import styled, { css } from 'styled-components';

import { styledTypography } from '@pkg/primitives';

import { tokens } from './AssetListingSheet.tokens';

interface SectionProps {
    $alignEnd?: boolean;
}

const typographyBase = css`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    letter-spacing: -0.02em;
`;

export const TitleLarge = styled.p`
    ${typographyBase};
    font-size: ${tokens.title.largeSize}px;
    font-weight: 700;
`;

export const TitleMedium = styled.p`
    ${typographyBase};
    font-size: ${tokens.title.mediumSize}px;
    font-weight: 700;
`;

///
/// Top-level sections

export const MainInterior = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${tokens.section.spacing}px;
    height: 100%;
`;

export const FooterInterior = styled.div`
    display: grid;
    gap: ${tokens.section.spacing * 2}px;
    padding-top: ${tokens.section.spacing}px;
    border-top: 1px solid rgb(255, 255, 255, 0.1);
`;

///
/// Nested sections

export const Section = styled.div<SectionProps>`
    display: grid;
    gap: ${tokens.section.gap}px;

    &:nth-child(1n + 2) {
        border-top: 1px solid rgb(255, 255, 255, 0.1);
        padding-top: ${tokens.section.spacing}px;
    }

    &:last-child {
        /* Needed to offset the scrollable container feather */
        padding-bottom: ${tokens.section.spacing}px;
    }

    ${({ $alignEnd }) =>
        $alignEnd &&
        css`
            margin-top: auto;
        `};
`;

export const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    gap: ${tokens.section.header.gap}px;
`;

export const SummaryRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: ${tokens.summary.row.gap}px;
`;
